// Card brand / last-four display for scene-2 review UI (ported from inline body_js).

export const CARD_BRAND_LABELS = Object.freeze({
	visa: 'Visa',
	mc: 'Mastercard',
	mastercard: 'Mastercard',
	amex: 'American Express',
	americanexpress: 'American Express',
	'american express': 'American Express',
	discover: 'Discover',
	diners: 'Diners Club',
	jcb: 'JCB',
	maestro: 'Maestro',
	cup: 'UnionPay',
	unionpay: 'UnionPay',
	electron: 'Visa Electron',
	hipercard: 'Hipercard',
	cartebancaire: 'Carte Bancaire',
});

export const formatCardBrand = (brand) => {
	if (!brand) {
		return '';
	}
	const key = String(brand).toLowerCase().trim();
	return CARD_BRAND_LABELS[key]
		|| CARD_BRAND_LABELS[key.replace(/[\s_-]/g, '')]
		|| (String(brand).charAt(0).toUpperCase() + String(brand).slice(1));
};

export const resolveCardBrand = (form, preAuthFields) => formatCardBrand(
	form?.payment?.details?.cardType
		|| form?.payment?.preAuth?.cardBrand
		|| preAuthFields?.cardBrand,
);

export const resolveCardLastFour = (form, preAuthFields) => form?.payment?.details?.lastFour
	|| form?.payment?.preAuth?.endDigits
	|| preAuthFields?.endDigits
	|| '';
